<template>
  <div
    class="guide-info"
    @click="goTo"
  >
    <div class="guide-info_data">
      <div class="info-head">
        <div
          v-if="comment?.guide?.first_name"
          class="name"
        >
          {{ comment.guide.first_name }}
        </div>
        <div
          v-if="rating"
          class="rating"
        >
          ★{{ rating }}
        </div>
      </div>
      <div
        v-if="comment?.guide?.determination"
        class="guide-description"
      >
        {{ comment.guide.determination }}
      </div>
      <div
        v-if="comment?.guide?.exp_count"
        class="exp-count"
      >
        {{ expDesc }} →
      </div>
    </div>
    <img
      v-if="comment?.guide?.avatar_url"
      :src="comment.guide.avatar_url"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { type GuidesComments } from '@/shared/api/generated/api';
  import { pluralize } from '@/shared/utils/language';

  const props = defineProps<{
    comment: GuidesComments;
  }>();

  const expDesc = computed(() =>
    props.comment.guide?.exp_count
      ? `${String(props.comment.guide.exp_count)} ${pluralize(props.comment.guide.exp_count, ['экскурсия', 'экскурсии', 'экскурсий'])}`
      : '',
  );

  const rating = computed(() => {
    return props.comment.guide?.rating?.toFixed(2);
  });

  const emit = defineEmits(['guideClick']);

  const goTo = () => {
    if (props.comment.guide?.id) {
      emit('guideClick', props.comment.guide.id);
      window.open(`https://experience.tripster.ru/guide/${String(props.comment.guide.id)}/`, '_blank');
    }
  };
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;

  .guide-info {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: var(--alias-space-16);
    cursor: pointer;

    .info-head {
      display: flex;
      gap: var(--alias-radius-8);

      @include legacy-typography.base-400-300-semi;
    }

    .guide-description {
      color: var(--alias-color-text-subtle);

      @include legacy-typography.base-300-300-regular;
    }

    .exp-count {
      cursor: pointer;

      @include legacy-typography.base-300-300-regular;
    }

    img {
      width: 56px;
      height: 80px;
      object-fit: cover;
      border-radius: var(--alias-radius-8);
    }
  }
</style>
